'use client'

import {
  CheckboxGroupItem,
  CheckboxGroupRoot,
} from '@/components/ui/checkbox-group'

type CheckboxItem = {
  value: string
  label: string
}

type Props = {
  onFilterChange: (value: string[]) => void
  selectedValues: string[]
  items: CheckboxItem[]
}

export const FilterCheckbox = ({
  onFilterChange,
  selectedValues,
  items,
}: Props) => {
  return (
    <CheckboxGroupRoot
      name='filter-checkbox-group'
      value={selectedValues}
      onValueChange={(values: string[]) => onFilterChange(values)}
    >
      {items.map((item) => (
        <CheckboxGroupItem
          key={item.value}
          value={item.value}
          title={item.label}
        />
      ))}
    </CheckboxGroupRoot>
  )
}
